var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23.09 23.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M23.09,11.55c0,6.38-5.17,11.55-11.55,11.55S0,17.92,0,11.55H1.92c0,5.31,4.32,9.62,9.62,9.62s9.62-4.32,9.62-9.62S16.85,1.92,11.55,1.92c-2.67,0-5.09,1.1-6.83,2.86l1.98,1.98L0,8.08,1.26,1.33,3.35,3.42C5.44,1.31,8.34,0,11.55,0c6.38,0,11.55,5.17,11.55,11.55ZM10.58,5.77v7.7h6.74v-1.92h-4.81V5.77h-1.92Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.f0ae2f981b2ddcd8d0dfd478e6aa0265.svg";
export { ForwardRef as ReactComponent };